/* Shared countdown + code-copy for promo landing pages.
   Ends are FIXED UTC timestamps from section settings — never client-local
   dates, or a shopper in the wrong timezone sees "ended" early or late. */
(function () {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function tick(el, end) {
    var diff = end - Date.now();
    if (diff <= 0) {
      el.setAttribute('data-promo-ended', 'true');
      var msg = el.getAttribute('data-ended-text');
      if (msg) el.textContent = msg;
      return false;
    }
    var s = Math.floor(diff / 1000);
    var parts = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
    Object.keys(parts).forEach(function (k) {
      var slot = el.querySelector('[data-unit="' + k + '"]');
      if (slot) slot.textContent = pad(parts[k]);
    });
    return true;
  }

  function start(el) {
    var iso = el.getAttribute('data-promo-countdown');
    var end = Date.parse(iso);
    if (isNaN(end)) { console.warn('promo-countdown: bad date', iso); return; }
    if (!tick(el, end)) return;
    var id = setInterval(function () { if (!tick(el, end)) clearInterval(id); }, 1000);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-promo-countdown]').forEach(start);
    (root || document).querySelectorAll('[data-promo-copy]').forEach(function (b) {
      if (b.dataset.bound) return;
      b.dataset.bound = '1';
      b.addEventListener('click', function () {
        var code = b.getAttribute('data-promo-copy'), old = b.textContent;
        if (navigator.clipboard) navigator.clipboard.writeText(code);
        b.textContent = b.getAttribute('data-copied-text') || 'COPIED';
        setTimeout(function () { b.textContent = old; }, 1400);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  // re-init after theme editor re-renders a section
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
